'use client';

import CookieConsent from 'react-cookie-consent';

export const CONSENT_COOKIE_NAME = 'CookieConsent';

const COOKIE_DESCRIPTION =
	'We use cookies and similar technologies to enhance your user experience. Manage your preferences below.';

type CookieBannerProps = {
	onAccept: () => void;
	onDecline: () => void;
};
//
export default function CookieBanner({ onAccept, onDecline }: CookieBannerProps) {
	return (
		<CookieConsent
			location="none"
			disableStyles
			disableButtonStyles
			flipButtons
			cookieName={CONSENT_COOKIE_NAME}
			expires={150}
			enableDeclineButton
			buttonText="Accept"
			declineButtonText="Reject"
			onAccept={onAccept}
			onDecline={onDecline}
			containerClasses="cookie-banner fixed z-[9999] bottom-0 left-0  right-0 flex flex-col gap-4 p-4 min-[576px]:bottom-[2rem] min-[576px]:left-[2rem] min-[576px]:right-auto min-[576px]:max-w-[320px] min-[576px]:rounded-sm min-[576px]:p-4 min-[576px]:shadow-xl bg-primary-600 min-[576px]:bg-white"
			contentClasses="flex flex-col gap-2"
			buttonWrapperClasses="flex flex-col gap-3 w-full"
			buttonClasses="w-full rounded-sm py-3 px-4 text-sm font-semibold cursor-pointer border-0 bg-white text-primary-600 min-[576px]:bg-primary-600 min-[576px]:text-white hover:opacity-90 transition-opacity"
			declineButtonClasses="w-full rounded-none py-1 text-sm font-semibold cursor-pointer border-0 bg-transparent text-white min-[576px]:text-primary-600 hover:underline transition-colors"
			ariaAcceptLabel="Accept cookies"
			ariaDeclineLabel="Reject cookies"
		>
			<p className="text-base font-bold text-white min-[576px]:text-primary-600">
				This website uses cookies.
			</p>
			<p className="text-sm leading-relaxed text-white/80 min-[576px]:text-gray-600">
				{COOKIE_DESCRIPTION}
			</p>
		</CookieConsent>
	);
}
